import React, { useState, useEffect } from "react";

function SearchBar({ searchKey, setSearchKey }) {
  const [tempSearchKey, setTempSearchKey] = useState("");

  const handleInputChange = (e) => {
    //console.log(e.target.value);
    //setSearchKey(e.target.value);
    setTempSearchKey(e.target.value);

  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSearchKey(tempSearchKey)
    //console.log(searchKey);
  };

  return (
    <>
      <form
        className="d-flex"
        role="search"
        style={{ margin: "1em 1em 1em 0", padding: "1em 1em 1em 0" }}
        onSubmit={handleSubmit}
      >
        <input
          className="form-control"
          type="search"
          placeholder="Universite & Bölüm Şehir"
          aria-label="Ara"
          //value={tempSearchKey}
          onChange={handleInputChange}
        />
        <button
          style={{ margin: "0 0.5em" }}
          className="btn btn-dark"
          type="submit"
        >
          Ara
        </button>
      </form>
    </>
  );
}

export default SearchBar;
